/**
 * 限制输入框输入数字 奈何v-model.number不好用
 * @props [positive] 限制正整数
 * @props [float] 限制浮点数
 * @props [max, min] 最大值最小值
 * @example <input v-number.float.positive={ max: 100, min: 1 } type="text" />
 */
export default {
  inserted(el, binding, vnode) {
    let input_ele = null
    let el_tagName = el.tagName.toUpperCase()
    if (el_tagName === 'INPUT') {
      input_ele = el
    } else {
      // element-ui情况tagName是div
      let inputList = el.querySelectorAll('input')
      input_ele = inputList[0]
    }
    if (!input_ele) {
      return
    }
    let { max = null, min = null, limit = null } = binding.value || {}
    if (max !== null && min !== null && max < min) {
      let temp = max
      max = min
      min = temp
    }
    input_ele.addEventListener('compositionstart', () => {
      vnode.inputLocking = true
    })
    input_ele.addEventListener('compositionend', () => {
      vnode.inputLocking = false
      input_ele.dispatchEvent(new Event('input'))
    })
    input_ele.addEventListener('input', () => {
      if (vnode.inputLocking) {
        return
      }
      let reg, res
      let val = input_ele.value
      if (binding.modifiers.positive && !binding.modifiers.float) {
        // 正整数.positive
        reg = /\D/g
        res = val.replace(reg, '')
      }
      if (!binding.modifiers.positive && !binding.modifiers.float) {
        // 默认正负整数
        reg = /\D/g
        res = val.replace(reg, '')
        if (val[0] === '-') {
          res = '-' + res
        }
      }

      if (binding.modifiers.float) {
        let _reg = /[^\.\d]/g
        res = val.replace(_reg, '')
        res = res.split('')
        let flag = 0
        for (let i = 0; i < res.length; i++) {
          if (res[i] === '.') {
            flag++
            if (flag > 1 || res[0] === '.') {
              res.splice(i, 1)
              i--
            }
          }
        }
        res = res.join('') // 正浮点数float.positive
        if (!binding.modifiers.positive) {
          // 正负浮点数.float
          if (val[0] === '-') {
            res = '-' + res
          }
        }
      }

      if (input_ele.value !== res) {
        input_ele.value = res
        input_ele.dispatchEvent(new Event('input'))
      }
    })
    input_ele.addEventListener('blur', () => {
      let val = input_ele.value
      // 末位为小数点则删除小数点
      let res = val.split('')
      if (res[res.length - 1] === '.') {
        res.splice(res.length - 1, 1)
      }
      res = res.join('')
      if (limit !== null && res) {
        res = (+res).toFixed(limit)
      }
      // 判断输入是否在范围内
      if (max !== null && res > max) {
        res = max
      }
      if (min !== null && res && res < min) {
        res = min
      }
      if (res) res = +res
      if (input_ele.value !== res) {
        input_ele.value = res
        input_ele.dispatchEvent(new Event('input'))
      }
    })
  },
}
